let lettersSpacesUnicodeRegex: RegExp | null = null;
let preferredDisplayNameUnicodeRegex: RegExp | null = null;

const lettersSpacesFallbackRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ'\-\s]*$/;
const preferredDisplayNameFallbackRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9'.,\-\s]{0,50}$/;

const getLettersSpacesUnicodeRegex = (): RegExp | null => {
  if (lettersSpacesUnicodeRegex !== null) {
    return lettersSpacesUnicodeRegex;
  }

  try {
    lettersSpacesUnicodeRegex = new RegExp(String.raw`^[\p{L}\p{M}'\-\s]*$`, 'u');
  } catch {
    lettersSpacesUnicodeRegex = null;
  }

  return lettersSpacesUnicodeRegex;
};

const getPreferredDisplayNameUnicodeRegex = (): RegExp | null => {
  if (preferredDisplayNameUnicodeRegex !== null) {
    return preferredDisplayNameUnicodeRegex;
  }

  try {
    preferredDisplayNameUnicodeRegex = new RegExp(String.raw`^[\p{L}\p{M}0-9'.,\-\s]{0,50}$`, 'u');
  } catch {
    preferredDisplayNameUnicodeRegex = null;
  }

  return preferredDisplayNameUnicodeRegex;
};

export const isLettersSpacesTextValid = (value?: string | null): boolean => {
  if (!value) {
    return true;
  }

  const unicodeRegex = getLettersSpacesUnicodeRegex();

  if (unicodeRegex) {
    return unicodeRegex.test(value);
  }

  return lettersSpacesFallbackRegex.test(value);
};

export const isPreferredDisplayNameValid = (value?: string | null): boolean => {
  if (!value) {
    return true;
  }

  const unicodeRegex = getPreferredDisplayNameUnicodeRegex();

  if (unicodeRegex) {
    return unicodeRegex.test(value);
  }

  return preferredDisplayNameFallbackRegex.test(value);
};
